/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { OfferCardOpsUsers } from "./offer-card-ops-users";
import { OfferT } from "../../../domain";
import React from "react";
import { getLocationFormat } from "../../../../../old/utils/parseData";
import { useTranslation } from "react-i18next";
import {
  InfoIcon,
  PinIcon,
  ShoppingCartIcon,
  TruckIcon,
} from "../../../../../shared/infrastructure";

type OfferCardFareProps = {
  offer: OfferT;
};

export const OfferCardFare = ({
  offer,
}: OfferCardFareProps): React.ReactElement => {
  const [t] = useTranslation("global");

  return (
    <section className="grid h-full max-w-full content-between gap-[8px]">
      <section className="grid content-start gap-[8px]">
        {offer.type === "single" && (
          <section className="grid grid-cols-[12px_1fr_auto] items-center gap-[4px]">
            <span />
            <span className="overflow-hidden text-ellipsis whitespace-pre-wrap text-[10px] font-[300] text-[#484848]">
              {t<string>(
                "context.private.components.offer-card-score.lookup-rate"
              )}
            </span>
            <span className="ml-auto text-[12px] font-[400] text-[#484848]">
              {offer.lookup_rate
                ? `$${offer.lookup_rate.toLocaleString("en-US")} USD`
                : "- -"}
            </span>
          </section>
        )}
        {offer.type === "single" && (
          <section className="grid grid-cols-[12px_1fr_auto] items-center gap-[4px]">
            <span />
            <span className="overflow-hidden text-ellipsis whitespace-pre-wrap text-[10px] font-[300] text-[#484848]">
              {t<string>("context.private.components.offer-card-fare.max-buy")}
            </span>
            <span className="ml-auto text-[12px] font-[400] text-[#484848]">
              {offer.max_buy
                ? `$${offer.max_buy.toLocaleString("en-US")} USD`
                : "- -"}
            </span>
          </section>
        )}
        {offer.type === "single" && (
          <section className="grid grid-cols-[12px_1fr_auto] items-center gap-[4px]">
            <ShoppingCartIcon width={12} height={12} fill="black" />
            <span className="overflow-hidden text-ellipsis whitespace-pre-wrap text-[10px] font-[700] text-[#484848]">
              {t<string>(
                "context.private.components.offer-card-fare.customer-rate"
              )}
            </span>
            <span className="ml-auto text-sm font-normal text-[#4CAF50]">
              {offer.total_charge
                ? `$${offer.total_charge.toLocaleString("en-US")} USD`
                : "- -"}
            </span>
          </section>
        )}
      </section>

      <section className="mt-4 grid content-start gap-[8px]">
        <section className="grid grid-cols-[1fr_auto] items-center justify-between gap-[10px]">
          <section className="grid grid-cols-[12px_1fr] items-center gap-1">
            <PinIcon width={12} height={12} fill="black" />
            <span className="overflow-hidden text-ellipsis whitespace-pre-wrap text-sm font-[300] capitalize text-[#484848]">
              MT {getLocationFormat(offer.truck_location)}
            </span>
          </section>
          {offer.is_empty_truck && (
            <section className="grid grid-cols-[12px_1fr] items-center gap-1 text-[#6296F8]">
              <TruckIcon width={12} height={12} />
              <span className="text-[10px] font-[700]">Empty Truck</span>
            </section>
          )}
        </section>
        <section className="grid grid-cols-[12px_1fr] items-center gap-1">
          <InfoIcon width={12} height={12} fill="black" />
          <span className="ml-[2px] overflow-hidden text-ellipsis whitespace-pre-wrap text-[10px] font-[300] text-[#484848]">
            {offer.comments || offer.status_comment || "- -"}
          </span>
        </section>
        <section className="relative grid gap-[4px]">
          <OfferCardOpsUsers
            opsUser={offer.customer?.ops_user_1 || "--"}
            tooltipText="Manager"
          />
        </section>
        <section className="relative grid gap-[4px]">
          <OfferCardOpsUsers
            opsUser={offer.customer?.ops_user_2 || "--"}
            tooltipText="Ops User"
          />
        </section>
      </section>
    </section>
  );
};
